import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { SvgIconsModule } from "src/app/module/svg.module";

/**
 * The "nothing here yet" placeholder — sprite illustration + heading +
 * optional sub-line — previously duplicated by shortcuts, dashboard and
 * flyshare.
 *
 * Layout comes from the GLOBAL `.empty-state` rules in
 * `src/assets/styles/app.scss` (global styles ignore view encapsulation, so
 * they style this template's `.empty-state` div the same as they styled the
 * hosts' inline copies). Visibility conditions (`*ngIf`) stay at the call
 * site on the `<app-empty-state>` element.
 */
@Component({
  selector: "app-empty-state",
  standalone: true,
  imports: [CommonModule, SvgIconsModule],
  templateUrl: "./empty-state.component.html",
})
export class EmptyStateComponent {
  /** Sprite id from assets/sprite/svg-set.svg. */
  @Input() icon = "icon-ico-empty";

  /** Headline, e.g. "No FlyCuts Added". */
  @Input() heading = "";

  /** Optional secondary line under the heading (flyshare renders none). */
  @Input() subtext?: string;
}
